<template>
    <div class="index-container">
        <b-loading :active="loading"></b-loading>


        <top-section>{{ title }}</top-section>

        <table-section :data="items"
                       :columns="columns"
                       :searchable="searchable"
                       :model="$route.params.resource"
                       :pagination-endpoint="'/' + $route.params.resource + '/' + $route.params.action"
                       :pagination-route="'/' + $route.params.resource + '/' + $route.params.action"
                       :checkable="$route.params.resource == 'season' ? true : false">
        </table-section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            columns: [],
            items: {},
            title: '',
            searchable: false
        };
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {
            this.loading = true;
            if (this.$route.params.resource === 'brand') {
                this.searchable = true;
            }
            axios.get(`/columns/${this.$route.params.resource}`).then(response => {
                this.columns = response.data;
                axios.get(`/title/${this.$route.params.resource}`)
                    .then(response => this.title = response.data)
                axios.get(`/${this.$route.params.resource}/index`, {params: {paginate: true}})
                    .then(response => {
                        this.items = response.data
                        this.loading = false;
                    })
            })
        }
    },
    watch: {
        $route(to, from) {
            if (to.path !== from.path) {
                this.initPage();
            }
        }
    }
};
</script>
